import { Component, OnInit, Inject, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators} from '@angular/forms';

@Component({
  selector: 'app-number-picker',
  templateUrl: './number-picker.component.html',
  styleUrls: ['./number-picker.component.scss'],
  providers: [  ]
})
export class NumberPickerComponent implements OnInit {
  @Input("value") public value = 1;
  @Input("max") public max: number;

  constructor() {

  }

  ngOnInit() {

  }

  more() {
    this.value = this.value >= this.max  ? this.value : this.value + 1;
  }

  less() {
    this.value = this.value <= 1 ? 1 : this.value - 1;
  }

  onKeyPress(e) {
    console.log(this.value);
    return this.value >= this.max ? false : true;
  }

}
